import {
    SET_CAP_DOWN_PAYMENT,
    SET_CAP_TERM,
    SET_SHOW_CAP,
    SET_CAP,
} from './constants';

export const setCAPDownPayment = capDownPayment => ({
    type: SET_CAP_DOWN_PAYMENT,
    capDownPayment,
});

export const setCAPTerm = capTerm => ({
    type: SET_CAP_TERM,
    capTerm,
});


export const setShowCAP = showCAP => ({
    type: SET_SHOW_CAP,
    showCAP,
});

export const setCAP = cap => ({
    type: SET_CAP,
    cap,
});



// WEBPACK FOOTER //
// ./src/containers/common/cap/actions.js